/**
 * PDP: com thumbnail_slider, só .is-active tem largura → o slider JS vê 1 slide,
 * não calcula offset e desativa prev+next — os cliques nem chegam ao handler útil.
 * Usamos media-gallery.setActiveMedia quando só há 1 slide "visível" no layout.
 */
(function () {
  function needsMediaNav(pg) {
    var slides = pg.querySelectorAll('[id^="Slide-"]');
    if (slides.length < 2) return false;
    var withWidth = 0;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].clientWidth > 0) withWidth++;
    }
    return withWidth <= 1;
  }

  function patch() {
    var PG = customElements.get("product-gallery");
    if (!PG || PG.prototype.__pdpArrowNavFixed) return;
    PG.prototype.__pdpArrowNavFixed = true;

    var origOnButtonClick = PG.prototype.onButtonClick;
    var origUpdate = PG.prototype.update;

    PG.prototype.update = function () {
      if (needsMediaNav(this)) {
        var slides = Array.prototype.slice.call(this.querySelectorAll('[id^="Slide-"]'));
        var activeIndex = slides.findIndex(function (el) {
          return el.classList.contains("is-active");
        });
        if (activeIndex === -1 || slides.length < 2) return;
        if (this.currentPageElement && this.pageTotalElement) {
          this.currentPageElement.textContent = String(activeIndex + 1);
          this.pageTotalElement.textContent = String(slides.length);
        }
        this.prevButton.toggleAttribute("disabled", activeIndex <= 0);
        this.nextButton.toggleAttribute("disabled", activeIndex >= slides.length - 1);
        return;
      }
      return origUpdate.call(this);
    };

    PG.prototype.onButtonClick = function (event) {
      var root = this.closest("media-gallery");
      var desktop =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(min-width: 750px)").matches;

      if (!root || !desktop || !needsMediaNav(this)) {
        return origOnButtonClick.call(this, event);
      }

      var slides = Array.prototype.slice.call(this.querySelectorAll('[id^="Slide-"]'));
      var activeIndex = slides.findIndex(function (el) {
        return el.classList.contains("is-active");
      });
      if (activeIndex === -1 || slides.length < 2) {
        return origOnButtonClick.call(this, event);
      }

      var delta = event.currentTarget.name === "next" ? 1 : -1;
      var nextIndex = activeIndex + delta;
      if (nextIndex < 0 || nextIndex >= slides.length) {
        return origOnButtonClick.call(this, event);
      }

      var nextSlide = slides[nextIndex];
      var mediaId = nextSlide.dataset.mediaId;
      if (!mediaId || typeof root.setActiveMedia !== "function") {
        return origOnButtonClick.call(this, event);
      }

      event.preventDefault();
      root.setActiveMedia(mediaId, false, true);
      this.resetPages();
      this.update();

      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          bubbles: true,
          detail: {
            currentPage: nextIndex + 1,
            currentElement: nextSlide,
          },
        }),
      );
    };
  }

  if (customElements.get("product-gallery")) {
    patch();
  } else {
    customElements.whenDefined("product-gallery").then(patch);
  }

  /** Instâncias já criadas antes do patch: reaplicar update para liberar botões */
  function refreshExisting() {
    document.querySelectorAll("product-gallery").forEach(function (el) {
      if (typeof el.update === "function" && needsMediaNav(el)) {
        el.update();
      }
    });
  }

  function scheduleRefresh() {
    requestAnimationFrame(refreshExisting);
    setTimeout(refreshExisting, 100);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleRefresh);
  } else {
    scheduleRefresh();
  }
  window.addEventListener("load", refreshExisting);
})();
